var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createClient, createConfig } from "@hey-api/client-fetch";
import debug from "debug";
import { getGoogleReCaptchaToken } from "@jti/fe-clients";
import { sanitizeBaseUrl } from "../../../../utils";
import { getComplaints, getUsersPublicDomainConfiguration, updateConsents, updateCustomAttribute, updateCustomAttributes, } from "../../../evo-client/__generated__";
import { prepareEvoCustomAttributes } from "./utils/prepareCustomAttributes";
const log = debug("desjti:api:UserCustomAttrsApiEvoV5");
export class UserCustomAttrsApiEvo {
    constructor({ baseUrl, tenantToken, ciamToken, recaptchaId = "", userUuid, }) {
        this.name = "UserCustomAttrsApi";
        this.tenantToken = tenantToken;
        this.ciamToken = ciamToken;
        this.userUuid = userUuid;
        this.recaptchaId = recaptchaId;
        const url = sanitizeBaseUrl(baseUrl);
        const config = createConfig({ baseUrl: url, throwOnError: true });
        this.client = createClient(config);
    }
    getCustomAttributes() {
        return __awaiter(this, void 0, void 0, function* () {
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { data, response } = yield getUsersPublicDomainConfiguration({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    // added for compatibility with EVO v4
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                },
            });
            const customAttributes = data === null || data === void 0 ? void 0 : data.custom_attributes;
            log("Custom attributes from API", customAttributes);
            return {
                data: prepareEvoCustomAttributes(customAttributes),
                statusCode: response.status,
            };
        });
    }
    write(updatedCustomAttr) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            log("Writing custom attributes", updatedCustomAttr);
            const { data } = yield updateCustomAttributes({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-USER-TOKEN": this.ciamToken,
                },
                path: {
                    uuid: this.userUuid,
                },
                body: updatedCustomAttr,
            });
            return {
                dob: (_a = data === null || data === void 0 ? void 0 : data.date_of_birth) !== null && _a !== void 0 ? _a : "",
                email: (_b = data === null || data === void 0 ? void 0 : data.email) !== null && _b !== void 0 ? _b : "",
                firstname: (_c = data === null || data === void 0 ? void 0 : data.first_name) !== null && _c !== void 0 ? _c : "",
                lastname: (_d = data === null || data === void 0 ? void 0 : data.last_name) !== null && _d !== void 0 ? _d : "",
            };
        });
    }
    writeConsents(updatedCustomAttr) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            yield updateConsents({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-USER-TOKEN": this.ciamToken,
                },
                path: {
                    uuid: this.userUuid,
                },
                body: {
                    consents: (_b = (_a = updatedCustomAttr.consents) === null || _a === void 0 ? void 0 : _a.map((consent) => {
                        var _a;
                        return ({
                            id: consent.id,
                            accepted: (_a = consent.accepted) !== null && _a !== void 0 ? _a : false,
                            one_off: consent.one_off,
                        });
                    })) !== null && _b !== void 0 ? _b : [],
                },
            });
            if (!updatedCustomAttr.preferredLanguage) {
                log("Skipping sending preferred language, because it was not provided");
                return;
            }
            yield updateCustomAttribute({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-USER-TOKEN": this.ciamToken,
                },
                path: {
                    uuid: this.userUuid,
                    customAttribute: "preferredLanguage",
                },
                body: {
                    value: updatedCustomAttr.preferredLanguage,
                },
                throwOnError: false,
            });
        });
    }
    getIsUserHasComplaints() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const result = yield getComplaints({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-USER-TOKEN": this.ciamToken,
                },
                path: {
                    uuid: this.userUuid,
                },
            });
            return (_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.has_complaints) !== null && _b !== void 0 ? _b : false;
        });
    }
}
//# sourceMappingURL=UserCustomAttrsApiEvo.v5.js.map